import React from "react";
import "./App.css";
// import Album from  './components/albumc'
import Chapter from "./components/Chapter";
import LandingPage from "./components/CatalogPage/CatalogPage";
import { HashRouter as Router, Route } from "react-router-dom";

function App() {
  return (
    <div className="App">
      <Router>
        <div>
          <Route exact path="/" component={LandingPage}></Route>
          {/* <Route exact path="/lesson/:lid" component={Album}></Route> */}
          <Route
            exact
            path="/lesson/:lid/chapter/:cid"
            component={Chapter}
          ></Route>
        </div>
      </Router>
    </div>
  );
}

export default App;
